import {  
  StandardPricing,
  TierPricingComponent,
  PackagePricing,
  CustomPricing,
} from "../../../shared/components";
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import React from "react"; 
import { PricingPageInputModel } from "../../../shared/models";
import { ItemBillingType, PricingModel } from "../../../shared/enums";
import { DescriptionCell, LabelCell } from "../../../shared/styles";

type IProps = {
  pricing: PricingPageInputModel | null;
};

class ItemPricingSection extends React.Component<IProps> {
  get isRecurringBilling() {
    return this.props.pricing?.billingType === ItemBillingType.Recurring;
  }

  get pricingModel() {
    return this.isRecurringBilling
      ? this.props.pricing?.recurringSettings?.pricingModel
      : this.props.pricing?.termSettings?.pricingModel;
  }
  get pricingComponent() {
    const standardPricing = this.isRecurringBilling
      ? this.props.pricing?.recurringSettings?.standardPricing
      : this.props.pricing?.termSettings?.standardPricing;

    const volumePricing = this.isRecurringBilling
      ? this.props.pricing?.recurringSettings?.volumePricing
      : this.props.pricing?.termSettings?.volumePricing;

    const tierPricing = this.isRecurringBilling
      ? this.props.pricing?.recurringSettings?.volumePricing
      : this.props.pricing?.termSettings?.tieredPricing;

    const packagePricing = this.isRecurringBilling
      ? this.props.pricing?.recurringSettings?.packagePricing
      : this.props.pricing?.termSettings?.packagePricing;
    const customPricing = this.isRecurringBilling
      ? this.props.pricing?.recurringSettings?.customPricing
      : this.props.pricing?.termSettings?.customPricing;
    switch (this.pricingModel) {
      case PricingModel.Standard:
        if (!standardPricing) return null;
        return (
          <StandardPricing
            renderAsLabels={true}
            standardPricing={standardPricing}
            onUpdate={() => {}}
          />
        );
      case PricingModel.Volume:
        if (!volumePricing) return null;
        return (
          <TierPricingComponent
            renderAsLabels={true}
            totalPrice={0}
            pricingType={PricingModel.Volume}
            tier={volumePricing}
            onUpdateTier={() => {}}
          />
        );
      case PricingModel.Tiered:
        if (!tierPricing) return null;
        return (
          <TierPricingComponent
            renderAsLabels={true}
            totalPrice={0}
            pricingType={PricingModel.Tiered}
            tier={tierPricing}
            onUpdateTier={() => {}}
          />
        );
      case PricingModel.Package:
        if (!packagePricing) return null;
        return (
          <PackagePricing
            renderAsLabels={true}
            package={packagePricing}
            onUpdate={() => {}}
          />
        );
      case PricingModel.Custom:
        if (!customPricing) return null;
        return (
          <CustomPricing
            renderAsLabels={true}
            onUpdate={() => {}}
            customPricing={customPricing}
          />
        );
      default:
        return <></>;
    }
  }

  row(label: string, rightColumn: string | React.ReactNode) {
    return (
      <FlexContainer className="label-description-row">
        <LabelCell>
          <CustomLabel>{label}</CustomLabel>
        </LabelCell>
        <DescriptionCell>{rightColumn}</DescriptionCell>
      </FlexContainer>
    );
  }

  render() {
    return (
      <>
        <CustomLabel fontSize="20px" fontWeight="600" margin="30px 0px 30px">
          Pricing
        </CustomLabel>
        {this.row("Pricing Option", this.pricingModel)}
        {this.pricingComponent}
      </>
    );
  }
}

export default ItemPricingSection;
